import React, { useEffect } from 'react'
import clsx from 'clsx'
import moment from 'moment-jalaali'
// import { v4 as uuid } from 'uuid'
import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
import {
  Box,
  // Button,
  Card,
  CardHeader,
  Chip,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  makeStyles,
} from '@material-ui/core'
import ArrowLefIcon from '@material-ui/icons/ArrowLeft'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  selectorRecentlyPayment,
  getRecentlyPayments,
} from '../../../app/slices/dashboardSlice'

const PAYMENT_STATUS = {
  100: 'جدید',
  101: 'در حال پرداخت',
  102: 'تایید شده',
  103: 'پرداخت موفق',
  104: 'ناموفق',
}

// const data = [
//   {
//     id: uuid(),
//     ref: 'CDD1049',
//     amount: 30.5,
//     customer: {
//       name: 'کاربر ۱',
//     },
//     createdAt: 1555016400000,
//     status: 'درحال بررسی',
//   },
//   {
//     id: uuid(),
//     ref: 'CDD1048',
//     amount: 25.1,
//     customer: {
//       name: 'کاربر۲',
//     },
//     createdAt: 1555016400000,
//     status: 'انجام شده',
//   },
//   {
//     id: uuid(),
//     ref: 'CDD1047',
//     amount: 10.99,
//     customer: {
//       name: 'کاربر ۳',
//     },
//     createdAt: 1554930000000,
//     status: 'بازگشت وجه',
//   },
//   {
//     id: uuid(),
//     ref: 'CDD1046',
//     amount: 96.43,
//     customer: {
//       name: 'کاربر ۴',
//     },
//     createdAt: 1554757200000,
//     status: 'خطا',
//   },
//   {
//     id: uuid(),
//     ref: 'CDD1045',
//     amount: 32.54,
//     customer: {
//       name: 'کاربر ۶',
//     },
//     createdAt: 1554670800000,
//     status: 'انجام شده',
//   },
//   {
//     id: uuid(),
//     ref: 'CDD1044',
//     amount: 16.76,
//     customer: {
//       name: 'کاربر ۷',
//     },
//     createdAt: 1554670800000,
//     status: 'انجام شده',
//   },
// ]

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '20px',
  },
  button: {
    color: theme.palette.text.primary,
  },
  actions: {
    justifyContent: 'flex-end',
  },
}))

const LatestOrders = ({ className, ...rest }) => {
  const classes = useStyles()
  const payments = useSelector(selectorRecentlyPayment)
  const dispatch = useDispatch()
  // const [orders] = useState(data)

  useEffect(() => {
    dispatch(getRecentlyPayments())
  }, [])

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardHeader title="تراکنش های اخیر" />
      <Divider />
      <PerfectScrollbar>
        <Box minWidth={800}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  شناسه
                </TableCell>
                <TableCell>
                  کاربر
                </TableCell>
                <TableCell>
                  مبلغ تراکنش
                </TableCell>
                <TableCell sortDirection="desc">
                  <Tooltip
                    enterDelay={300}
                    title="Sort"
                  >
                    <TableSortLabel
                      active
                      direction="desc"
                    >
                      تاریخ
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  وضعیت
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments?.map((order) => (
                <TableRow
                  hover
                  key={order?.id}
                >
                  <TableCell>
                    {order?.entityId}
                  </TableCell>
                  <TableCell>
                    {order?.payer?.userName}
                  </TableCell>
                  <TableCell>
                    {order?.price}
                  </TableCell>
                  <TableCell>
                    {moment(order?.createDate).format('jYYYY/jMM/jDD')}
                  </TableCell>
                  <TableCell>
                    <Chip
                      color="primary"
                      label={PAYMENT_STATUS[order?.payer?.status]}
                      size="small"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <Box
        display="flex"
        justifyContent="flex-end"
        p={2}
      >
        <Link
          // color="primary"
          to="/app/sales"
          endIcon={<ArrowLefIcon />}
          size="small"
          variant="text"
          className={classes.button}
        >
          مشاهده همه
        </Link>
      </Box>
    </Card>
  )
}

LatestOrders.propTypes = {
  className: PropTypes.string,
}

export default LatestOrders
